<template>
    <div v-if="show" class="modal">
        <div class="modal-content max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <span class="close" @click="closeModal">&times;</span>
            <form @submit.prevent="book">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <div class="pb-8 pr-6 w-full lg:w-1/2">
                        <text-input v-model="form.name" :error="form.errors.name" label="Ім'я"/>
                    </div>
                    <div class="pb-8 pr-6 w-full lg:w-1/2">
                        <text-input v-model="form.phone" :error="form.errors.phone" label="Телефон"/>
                    </div>
                    <div class="pb-8 pr-6 w-full lg:w-1/2">
                        <text-input v-model="form.quantity" :error="form.errors.quantity" label="Кількість рибаків"/>
                    </div>
                    <div class="pb-8 pr-6 w-full lg:w-1/2">
                        <p class="mb-2 font-bold">Місце риблки: </p>
                        <p>{{ selectedPoint.name }}</p>
                    </div>
                    <div class="pb-8 pr-6 w-full lg:w-1/2">
                        <p class="mb-2 font-bold">Номер місця риблки: </p>
                        <div>{{ selectedPoint.lake_name }} -> {{ selectedPoint.number }}</div>
                    </div>
                    <select-input
                        v-model="form.typeId"
                        :error="form.errors.typeId"
                        class="pb-8 pr-6 w-full lg:w-1/2"
                        label="Тип рибалки"
                    >
                        <option v-for="type in types" :key="type.id" :value="type.id">
                            {{ type.name }} ({{ type.description }})
                        </option>
                    </select-input>
                    <select-input
                        v-model="form.categoryId"
                        :error="form.errors.categoryId"
                        class="pb-8 pr-6 w-full lg:w-1/2"
                        label="Вид рибалки"
                    >
                        <option v-for="category in categories" :key="category.id" :value="category.id">
                            {{ category.name }}
                        </option>
                    </select-input>
                    <date-picker
                        v-model="form.date"
                        :disabledDays="disabledDays"
                        :error="form.errors.date"
                        label="Дата рибалки"
                    />
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
                        Забронировать
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import LoadingButton from "@/Shared/LoadingButton"
import SelectInput from "@/Shared/SelectInput"
import DatePicker from "@/Shared/DatePicker"
import TextInput from "@/Shared/TextInput"
import axios from "axios";

export default {
    name: "InfoModal",
    components: {
        TextInput,
        DatePicker,
        SelectInput,
        LoadingButton
    },
    props: {
        selectedPoint: Object,
        show: Boolean,
        types: Array,
        categories: Array,
        defaultDisabledDays: {
            type: Object,
            default: () => ({}),
        }
    },
    data() {
        return {
            form: this.$inertia.form({
                name: '',
                phone: '',
                quantity: 1,
                lakeId: null,
                latitude: '',
                longitude: '',
                number: '',
                date: [],
                typeId: null,
                categoryId: null,
                pointName: '',
                pointId: null,
            }),
            disabledDays: []
        }
    },
    watch: {
        selectedPoint: {
            deep: true,
            handler(newVal) {
                this.updateFormFields(newVal);
            }
        },
        'form.typeId': {
            immediate: true,
            handler(newVal) {
                this.fetchDisabledDays(newVal);
            }
        }
    },
    methods: {
        closeModal() {
            this.$emit('update:show', false);
            this.form.reset();
        },
        book() {
            this.form.post(this.$route('book.points'))
        },
        updateFormFields(point) {
            this.form.pointName = point.name;
            this.form.lakeId = point.lake_id;
            this.form.latitude = point.latitude;
            this.form.longitude = point.longitude;
            this.form.number = point.number;
            this.form.pointId = point.id;
        },
        fetchDisabledDays(typeId) {
            if (typeId && this.form.lakeId) {
                axios.get(`/disabled-days/${this.form.lakeId}`, { params: { typeId: typeId } })
                    .then(response => {
                        this.disabledDays = response.data.disabled_days;
                    })
                    .catch(error => {
                        console.error('Error fetching disabled days:', error);
                    });
            }
        }
    },
    mounted() {
        this.disabledDays = this.defaultDisabledDays
        if (this.selectedPoint) {
            this.updateFormFields(this.selectedPoint);
        }
        if (this.types.length > 0) {
            this.form.typeId = this.types[0].id;
        }
        if (this.categories.length > 0) {
            this.form.categoryId = this.categories[0].id;
        }
    }
};
</script>

<style scoped>
.modal {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}
</style>
